







































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { Transceiver, TransceiversApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
		routerLinkButton,
	},
})
export default class TransceiversList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'serialNumber', sortable: true },
			{ key: 'thingId', label: 'thingID', sortable: true },
			// {key: 'uniqueId', sortable: true},
			{ key: 'imei', sortable: true },
			// {key: 'site.name', label: 'Site', sortable: false},
			// {key: 'products.0.supplierNumber', label: 'Products', sortable: false},
			{ key: 'firmwareVersion', label: 'version', sortable: true },
			// {key: 'thingGroupName', label: 'otaGroup', sortable: true},
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public url = process.env.VUE_APP_API_URL + '/exports/get/transceivers';

	public fileOptions = {
		url: process.env.VUE_APP_API_URL + '/vats/uploadImage',
		headers: {
			'Cache-Control': null,
			'X-Requested-With': null,
			Authorization: 'Bearer ' + this.$auth.token(),
		},
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Classic Transceivers',
			field: 'type',
			type: 'checkbox',
			value: false,
		},
	];

	private api: TransceiversApi;

	constructor() {
		super();
		this.api = new TransceiversApi();
	}

	public forceFileDownload(response) {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', 'transceivers.csv');
		document.body.appendChild(link);
		link.click();
	}

	public download() {
		this.$http({
			method: 'get',
			url: this.url,
			responseType: 'arraybuffer',
		})
			.then(response => {
				this.forceFileDownload(response);
			})
			.catch(() => console.log('error occured'));
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'transceivers-datatable');
	}

	public clickTable(item: Transceiver, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'transceivers.view',
				params: { transceiverId: item.id },
			} as any);
			window.open(routeData.href);
		} else {
			this.$router.push({
				name: 'transceivers.view',
				params: { transceiverId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];

		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				if (filter.field === 'type' && filter.value) {
					return { field: 'type', value: ['01', '02', '03', '04'] };
				}
				return { field: filter.field, value: filter.value };
			});
			// const regexThingID = /([\d\D]{24})/;
			const regexThingID = /\b([\d\D]{25})\b/;
			if (this.state.search !== null && this.state.search.match(regexThingID)) {
				filters.push({ field: 'thingId', value: this.state.search });
			} else if (this.state.search !== null) {
				this.state.search = this.state.search.replaceAll(' ', '-'); // Automatically swaps spaces to dashes to make it easier for mobile
				filters.push({ field: 'custom', value: this.state.search });
			}

			const response = await this.api.getTransceivers(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'site,products' } }),
			);

			data = response.data.data;
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;

			console.log(e);
		}
		return data;
	}
}
